__turbopack_context__.v({
  "hideMobile": "FUXqpG_hideMobile",
  "showMobile": "FUXqpG_showMobile",
});
